import { useState } from 'react';
import Select from 'react-select';
import { Form, Spinner } from 'react-bootstrap';
import { useQuery } from 'react-query';
import {
    optionsTheme,
    theme,
    tradeControl,
} from '../../../styles/react-select-config';
import InvoiceHttpService from '../../../services/http/invoice-http';
import { useOnlineStore } from '../../../contexts/onlineStoreContext';
import { StyledDiv } from './styles';
import BranchHttpService from '../../../services/http/branch-http';
import handleResponseError from '../../../utils/handleResponseError';

interface Props {
    invoice: any;
}

interface BranchProps {
    label: string;
    value: string;
}

const Branch = (props: Props) => {
    const { invoice } = props;
    const { setCart } = useOnlineStore();

    const [loading, setLoading] = useState(false);

    async function loadBranches() {
        const response: any = await BranchHttpService.readMany({});

        const branches: BranchProps[] = [];

        if (response?.data?.data) {
            response.data.data.map((branch: any) =>
                branches.push({
                    label: branch.name,
                    value: `${branch.companyCode},${branch.branchCode}`,
                }),
            );
        }

        return branches;
    }

    const branches = useQuery<BranchProps[]>('branches', loadBranches);

    const handleBranchChange = async (event: any) => {
        if (event.value !== invoice.erpTenantId) {
            setLoading(true);

            try {
                const response = await InvoiceHttpService.update({
                    ...invoice,
                    erpTenantId: event.value,
                });

                setCart(response.data);
            } catch (error) {
                handleResponseError(
                    error,
                    'Ocorreu um erro ao atualizar filial.',
                );
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <StyledDiv>
            {branches.isLoading ? (
                <Spinner animation="border" />
            ) : (
                <div style={{ width: '100%' }}>
                    <Form.Label>Filial responsável pela expedição</Form.Label>
                    <Select
                        placeholder="Selecione..."
                        className="form-control-nexen"
                        onChange={handleBranchChange}
                        value={
                            loading
                                ? { value: '', label: 'Atualizando...' }
                                : branches.data.find(
                                      (branch: any) =>
                                          branch?.value === invoice.erpTenantId,
                                  )
                        }
                        options={branches.data}
                        styles={{
                            control: tradeControl,
                            option: optionsTheme,
                        }}
                        theme={theme}
                        isDisabled // TODO: Alterar para {!isAllowedStatus() || loading} quando for tratado as filiais
                    />
                </div>
            )}
        </StyledDiv>
    );
};

export default Branch;
